import React from 'react';
import { Alert } from '@material-ui/lab';
import { Box } from '@material-ui/core';
import reportLocales from 'globals/locales/report';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';

const {
  currentSelectionLabel,
  noFinalCategorySelectedLabel,
} = reportLocales.changeCategoryModal;

interface HelperAlertProps {
  currentSelection: string | null;
  currentSelectedCategory: string | null;
  currentSelectedSubCategory: string | null;
}

const HelperAlert: React.FC<HelperAlertProps> = ({ currentSelection }) => {
  const status = currentSelection ? 'success' : 'info';
  return (
    <Box marginBottom={2}>
      <Alert severity={status}>
        {currentSelection ? (
          <FsBody>
            <span>{`${currentSelectionLabel}: `}</span>
            <FsBodyBold component="span">{currentSelection}</FsBodyBold>
          </FsBody>
        ) : (
          <FsBody>{noFinalCategorySelectedLabel}</FsBody>
        )}
      </Alert>
    </Box>
  );
};

export default HelperAlert;
